import moment from "moment";
import { DATE_FORMAT } from "../constants";

const parseDate = (val: any) => {
  if (val === null || val === undefined || val === "") return null;
  if (typeof val === "string" && /^\d{10,13}$/.test(val.trim())) {
    const num = Number(val.trim());
    return moment(num > 10000000000 ? num : num * 1000);
  }
  return moment(val);
};

export const dateConvert = (value: any) => {
  const m = parseDate(value);
  return m && m.isValid() ? m.format(DATE_FORMAT.REGULAR) : "";
};

export const standardDateConvert = (row: any) => {
  const m = parseDate(row);
  return m && m.isValid() ? m.format(DATE_FORMAT.STANDARD) : "";
};

export const secondDateConvert = (row: any) => {
  const m = parseDate(row);
  return m && m.isValid() ? m.format(DATE_FORMAT.DASH) : "";
};

export const dateAndTimeConvert = (row: any) => {
  const m = parseDate(row);
  return m && m.isValid() ? m.format(DATE_FORMAT.DATE_TIME) : "";
};
